import SelectIcon from '~/components/icons/SelectIcon';

const CompanySize = (props) => (
  <div className="cb-select">
    <select {...props}>
      <option />
      <option value="1-10">1-10</option>
      <option value="11-50">11-50</option>
      <option value="51-250">51-250</option>
      <option value="251-1K">251-1K</option>
      <option value="1K-5K">1K-5K</option>
      <option value="5K-10K">5K-10K</option>
      <option value="10K-50K">10K-50K</option>
      <option value="50K-100K">50K-100K</option>
      <option value="100K+">100K+</option>
    </select>

    <SelectIcon className="cb-arrow" />
  </div>
);

CompanySize.propTypes = {
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default CompanySize;
